import { Button, Box } from '@mui/material';

type ActionType = 'cancel' | 'pause' | 'resume';

interface ActionButtonProps {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  actionType: ActionType;
  disabled?: boolean;
}

const ACTION_COLORS: Record<ActionType, any> = {
  cancel: {
    bg: '#FF6B6B',
    hover: '#FF5252',
    active: '#E53935',
  },
  pause: {
    bg: '#FFC107',
    hover: '#FFB300',
    active: '#FFA000',
  },
  resume: {
    bg: '#4CAF50',
    hover: '#43A047',
    active: '#388E3C',
  },
};

const ActionButton = ({
  label,
  icon,
  onClick,
  actionType,
  disabled = false,
}: ActionButtonProps) => {
  const colors = ACTION_COLORS[actionType];

  return (
    <Button
      variant="contained"
      onClick={onClick}
      disabled={disabled}
      sx={{
        backgroundColor: colors.bg,
        textTransform: 'none',
        borderRadius: 2,
        px: 2.5,
        minWidth: 100,
        color: '#fff',
        '&:hover': { backgroundColor: colors.hover },
        '&:active': { backgroundColor: colors.active },
        '&.Mui-disabled': {
          backgroundColor: '#ccc',
          color: '#fff',
        },
      }}
      startIcon={
        <Box
          sx={{
            width: 22,
            height: 22,
            borderRadius: '50%',
            bgcolor: 'rgba(255,255,255,0.3)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {icon}
        </Box>
      }
    >
      {label}
    </Button>
  );
};

export default ActionButton;
